// IMPORTANT: Build gql after ANY changes to queries (client OR api)

import { graphql } from '@/client/services/api/graphql/gql';

export const listAssignmentRecipientsQuery: any = graphql(`
  query ListAssignmentRecipientsQuery(
    $assigneeId: IDQueryOperatorArgs
    $assigneeName: StringQueryOperatorArgs
    $assigner: IDQueryOperatorArgs
    $completed: BooleanQueryOperatorArgs
    $completedDate: DateQueryOperatorArgs
    $completionStatus: StringQueryOperatorArgs
    $contentId: IDQueryOperatorArgs
    $createdAt: DateQueryOperatorArgs
    $dueDate: DateQueryOperatorArgs
    $groupId: IDQueryOperatorArgs
    $includeTotalCount: Boolean! = true
    $ordering: [OrderBy!]
    $page: Int! = 0
    $pageSize: Int! = 500
    $workflowId: IDQueryOperatorArgs
    $unassigned: BooleanQueryOperatorArgs = { in: [true, false] }
  ) {
    assignments(
      assigneeId: $assigneeId
      assigneeName: $assigneeName
      assigner: $assigner
      completed: $completed
      completedDate: $completedDate
      completionStatus: $completionStatus
      contentId: $contentId
      createdAt: $createdAt
      dueDate: $dueDate
      groupId: $groupId
      includeTotalCount: $includeTotalCount
      ordering: $ordering
      page: $page
      pageSize: $pageSize
      workflowId: $workflowId
      unassigned: $unassigned
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        totalCount
      }
      edges {
        node {
          assignee {
            id
            fullName
          }
          id
          completionStatus
          completionPercentage
          createdAt
          dueDate
          completedDate
        }
      }
    }
  }
`);
